import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FraudAnalysis {
  riskLevel: 'HIGH' | 'MEDIUM' | 'LOW' | 'UNKNOWN';
  riskMessage: string;
  riskFactors: string[];
  investigationRequired: boolean;
  totalContracts: number;
  highRiskCount: number;
  mediumRiskCount: number;
  lowRiskCount: number;
  totalValue: number;
  patternsDetected: string[];
  recommendation: string;
}

export interface FraudAnalysisState {
  currentAnalysis: FraudAnalysis | null;
  contractDetails: any | null;
  showModal: boolean;
}

const initialState: FraudAnalysisState = {
  currentAnalysis: null,
  contractDetails: null,
  showModal: false,
};

const fraudAnalysisSlice = createSlice({
  name: 'fraudAnalysis',
  initialState,
  reducers: {
    setFraudAnalysis: (state, action: PayloadAction<FraudAnalysis>) => {
      state.currentAnalysis = action.payload;
    },
    setContractDetails: (state, action: PayloadAction<any>) => {
      state.contractDetails = action.payload;
    },
    showDetailModal: (state) => {
      state.showModal = true;
    },
    hideDetailModal: (state) => {
      state.showModal = false;
      state.contractDetails = null;
    },
    clearAnalysis: (state) => {
      state.currentAnalysis = null;
      state.contractDetails = null;
      state.showModal = false;
    },
  },
});

export const {
  setFraudAnalysis,
  setContractDetails,
  showDetailModal,
  hideDetailModal,
  clearAnalysis,
} = fraudAnalysisSlice.actions;

export default fraudAnalysisSlice.reducer;